import { appConfig } from '../../../appConfig';

/** CMS dynamic flag `EnableEdlpPrices` — map-time labelling + `availablePromotions` Loop filters. */
export const isEdlpPricesEnabled = (): boolean => {
    const flags = appConfig.coopSettings.featureFlags.dynamicFeatureFlags;
    if (!flags?.length) {
        return false;
    }

    const flag = flags.find((f) => f.name.toLowerCase() === 'enableedlpprices');
    return !!flag?.enabled;
};
